export function preparePayload(newFields, updatedFields) {
  let fieldsToAdd = newFields.map(field => {
    let { isNew, ...data } = field;  // remove isNew prop
    return data;
  });

  let updates = updatedFields.map(field => {
    let { isNew, ...data } = field;  // remove isNew prop
    return data;
  });
  return { 'new_fields': fieldsToAdd, 'updated_fields': updates };
}
